import { createContext, useContext, useEffect, useState } from 'react';
import { API_GET, DBRequest } from './api/api';
import Cookies from 'universal-cookie';
import { fetchConfig } from './fetchConfig';

const cookies = new Cookies();

// Create a context
const AppConfigContext = createContext();

export const AppConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);

  const fetchConfigJson = async () => {
    try {
      const config = await fetchConfig();
      fetchConfigApi(config);
    } catch (error) {
      console.error('Error fetching configuration:', error);
    }
  };

  function fetchConfigApi(config) {
    cookies.set('isLowPerformance', config.isLowPerformance || false, {
      path: '/',
    });

    const apiUrls = {
      API_PWFORGOT: `${config.apiUrl}/api/forgot-password`,
      API_PWRESET: `${config.apiUrl}/api/reset-password`,
      API_LOGIN: `${config.apiUrl}/api/login`,
      API_LOGOUT: `${config.apiUrl}/api/logout`,
      API_AUTH: `${config.apiUrl}/api/authorization`,
      API_URL: `${config.apiUrl}/api/${config.apiVersion}/`,
      API_MODULES: `${config.apiUrl}/api/${config.apiVersion}/modules/`,
      API_CSRF: `${config.apiUrl}/sanctum/csrf-cookie`,
    };
    // get global config from api
    DBRequest({
      config: apiUrls,
      path: 'config',
      method: API_GET,
      onResponse: (res) => handleResponse(res, apiUrls, config),
      onError: (res) => handleError(res, apiUrls, config),
      noAuth: true,
    });
  }

  function handleResponse(res, apiUrls, config) {
    var apiConfig = {};
    var companyAddress = {};
    res.data.forEach((configElement) => {
      var catConfig = {};
      configElement.items.forEach((configElementItem) => {
        if (
          configElement.api === 'owncompanydata' &&
          configElementItem.type === 'address'
        )
          return (companyAddress = configElementItem.value);

        if (configElementItem.key == 'paymentOptions') {
          return (catConfig[configElementItem.key] = configElementItem);
        } else {
          catConfig[configElementItem.key] = configElementItem.value;
        }
      });
      apiConfig[configElement.category] = catConfig;
    });

    /*console.log("CONFIG", {
      ...config,
      ...apiUrls,
      ...apiConfig,
    });*/
    applyConfig({
      ...config,
      ...apiUrls,
      ...apiConfig,
      companyAddress,
    });
  }

  function handleError(res, apiUrls, config) {
    applyConfig({
      ...config,
      ...apiUrls,
    });
  }

  function applyConfig(newConfig) {
    // read by numberConverter; set before children render with the new config
    cookies.set('decimalSeparator', newConfig.decimalSeparator, { path: '/' });
    setConfig(newConfig);
  }

  useEffect(() => {
    fetchConfigJson();
  }, []);

  return (
    <AppConfigContext.Provider value={{ config }}>
      {children}
    </AppConfigContext.Provider>
  );
};

// Custom hook to use the context
export const useAppConfig = () => {
  return useContext(AppConfigContext);
};
